export default __webpack_public_path__ + "static/media/email.8484ee74.svg";